import request from '@/utils/request';

export default {
    getTopCompany:function () {
        return request({
            url: "/word/platform/zhWordCompanyInformation/user/getTopCompany",
            method: "get"
        });
    },
    getProductsList:function(params){
        return request({
            url: "/word/platform/zhWordProducts/user/getProductsList",
            method: "get",
            params:params
        });
    },
    getOneProduct:function (id){
        return request({
            url: "/word/platform/zhWordProducts/user/getOneProduct",
            method: "get",
            params:{ id:id }
        });
    },
    getPlanList:function(params){
        return request({
            url: "/word/platform/zhWordPlan/user/getPlanList",
            method: "get",
            params:params
        });
    },
    getOnePlan:function (id){
        return request({
            url: "/word/platform/zhWordPlan/user/getPlanOne",
            method: "get",
            params:{ id:id }
        });
    },
    getOneEcology:function (){
        return request({
            url: "/word/platform/zhWordEcology/user/getOneEcology",
            method: "get"
        });
    },
    getAboutOne:function (){
        return request({
            url: "/word/platform/zhWordAbout/user/getAboutOne",
            method: "get"
        });
    },
    getNewsAndEvents:function (params){
        return request({
            url: "/word/platform/zhWordNews/user/getNewsList",
            method: "get",
            params: params
        });
    },
    getOneNews:function (params){
        return request({
            url: "/word/platform/zhWordNews/user/getNewsOne",
            method: "get",
            params: params
        });
    },
    getCloudList:function (params){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getCloudList",
            method: "get",
            params: params
        });
    },
    getCloudOne:function (id){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getCloudOne",
            method: "get",
            params:{ id:id }
        });
    },
    getYouKeNameByIp:function (){
        return request({
            url: "/sys/user/getYouKeNameByIp",
            method: "get",
        });
    },
    getAddressByCode:function (code, id){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getAddressByCode",
            method: "get",
            params:{ code:code, cloudId:id}
        });
    },
    getForumList:function (params){
        return request({
            url: "/word/platform/zhWordForumPost/user/listToUser",
            method: "get",
            params: params
        });
    },
    getForumByIdToUser:function (id){
        return request({
            url: "/word/platform/zhWordForumPost/user/getForumByIdToUser",
            method: "get",
            params:{ id:id }
        });
    },
    saveCommentToUser:function (obj){
        return request({
            url: "/word/platform/zhWordForumComment/user/saveCommentToUser",
            method: "post",
            data: obj
        });
    },
    getCommentByPostIdToUser:function (id, pageNum, pageSize){
        return request({
            url: "/word/platform/zhWordForumComment/user/getCommentByPostIdToUser",
            method: "get",
            params: {postId:id, pageNum:pageNum, pageSize:pageSize},
        });
    },
    getReplyByCommentIdToUser:function (id,pageNum,pageSize){
        return request({
            url: "/word/platform/zhWordForumComment/user/getReplyByCommentIdToUser",
            method: "get",
            params: {commentId:id, pageNum:pageNum, pageSize:pageSize},
        });
    },
    downLoadToUserByCode:function (code, uploadPath, name){
        return request({
            url: "/file/downLoadToUserByCode",
            method: "get",
            params:{ code:code, uploadPath:uploadPath, name:name }
        });
    },
    saveUser:function (userDTO){
        return request({
            url: "/sys/user/toUser/saveUserToUser",
            method: "post",
            data: userDTO
        });
    },
    getUserById:function (userId){
        return request({
            url: "/sys/user/toUser/getUserById",
            method: "post",
            params: {userId:userId}
        });
    },
    savePwdToUser:function (oldPassword,newPassword){
        return request({
            url: "/sys/user/toUser/savePwdToUser",
            method: "post",
            params: {oldPassword:oldPassword,newPassword:newPassword}
        });
    },
    deleteCommentToUser:function (commentId){
        return request({
            url: "/word/platform/zhWordForumComment/user/deleteCommentToUser",
            method: "delete",
            params: {commentId:commentId}
        });
    },
    getCommentToUser:function (params){
        return request({
            url: "/word/platform/zhWordForumComment/user/getCommentToUser",
            method: "get",
            params: params
        });
    },
    addviewCount:function (id){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/addviewCount",
            method: "post",
            params:{ id:id }
        });
    },
    getLabel:function (){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getLabel",
            method: "get",
        });
    },
    getClassify:function (){
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getClassify",
            method: "get",
        });
    },
    getPrivacyList:function (type){
        return request({
            url: "/word/platform/zhWordPrivacy/user/getPrivacyList",
            method: "get",
            params:{ type:type }
        });
    },
    getClLabelList:function (zhClToken){
        return request({
            url: "/word/zhcl/zhWordClLabel/user/userGetClLabelList",
            method: "get",
            params:{zhClToken: zhClToken}
        });
    },
    getCLHelpOne:function(params) {
        return request({
            url: "/word/zhcl/zhWordClHelp/user/getCLHelpOne",
            method: "get",
            params: params
        });
    },
    getClHelpList:function (params){
        return request({
            url: "/word/zhcl/zhWordClHelp/user/getClHelpList",
            method: "get",
            params: params
        });
    },
    getCLHelpOneByList:function(params) {
        return request({
            url: "/word/zhcl/zhWordClHelp/user/getCLHelpOneByList",
            method: "get",
            params: params
        });
    },


    getZsctLabelList:function (zhZsctToken){
        return request({
            url: "/word/zsct/zhWordZsctLabel/user/userGetZsctLabelList",
            method: "get",
            params:{zhZsctToken: zhZsctToken}
        });
    },
    getZsctHelpOne:function(params) {
        return request({
            url: "/word/zsct/zhWordZsctHelp/user/getZsctHelpOne",
            method: "get",
            params: params
        });
    },
    getZsctHelpList:function (params){
        return request({
            url: "/word/zsct/zhWordZsctHelp/user/getZsctHelpList",
            method: "get",
            params: params
        });
    },
    getZsctHelpOneByList:function(params) {
        return request({
            url: "/word/zsct/zhWordZsctHelp/user/getZsctHelpOneByList",
            method: "get",
            params: params
        });
    },

    getGwLabelList:function (gwGwToken){
        return request({
            url: "/word/gw/zhWordGwLabel/user/userGetGwLabelList",
            method: "get",
            params:{gwGwToken: gwGwToken}
        });
    },
    getGwHelpOne:function(params) {
        return request({
            url: "/word/gw/zhWordGwHelp/user/getGwHelpOne",
            method: "get",
            params: params
        });
    },
    getGwHelpList:function (params){
        return request({
            url: "/word/gw/zhWordGwHelp/user/getGwHelpList",
            method: "get",
            params: params
        });
    },
    getGwHelpOneByList:function(params) {
        return request({
            url: "/word/gw/zhWordGwHelp/user/getGwHelpOneByList",
            method: "get",
            params: params
        });
    },
    info: function (params) {
        return request({
            url: "/sys/user/info",
            method: "get",
            params: params,
        });
    },
    login: function (data) {
        return request({
            url: "/sys/login",
            method: "post",
            data: data,
        });
    },
    register: function (data) {
        return request({
            url: "/sys/register",
            method: "post",
            data: data,
        });
    },
    logout: function () {
        return request({
            url: "/sys/logout",
            method: "get",
        });
    },
    getCodeByUserId: function (userId) {
        return request({
            url: "/word/platform/zhWordCloudDepot/user/getCodeByUserId",
            method: "get",
            params: {userId: userId}
        });
    },
    saveJoinUsApply: function (data) {
        return request({
            url: "/word/platform/zhWordJoinUsApply/user/saveJoinUsApplyToUser",
            method: "post",
            data: data
        });
    },
}
